var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userPower)?_c('div',[(_vm.userPower.permissionList.indexOf(_vm.p) > -1)?_vm._t("default"):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }